import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class MissingParameters extends Component {
  render() {
    const {
      missingParameters
    } = this.props;
    const count = missingParameters.length;
    return /*#__PURE__*/_jsxs(UIAlert, {
      className: "text-left m-top-4",
      titleText: I18n.text('oauth.missingParameters.title', {
        count
      }),
      type: "danger",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.missingParameters.body",
        options: {
          count
        }
      }), /*#__PURE__*/_jsx(UIList, {
        styled: true,
        children: missingParameters.map(parameter => {
          return /*#__PURE__*/_jsx("span", {
            children: parameter
          }, parameter);
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "oauth.missingParameters.contact"
      })]
    });
  }
}
MissingParameters.propTypes = {
  missingParameters: PropTypes.arrayOf(PropTypes.string).isRequired
};